/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { aiUserFeedbackControllerCreate } from "./aiUserFeedbackControllerCreate";
import { aiUserFeedbackControllerDelete } from "./aiUserFeedbackControllerDelete";
import { aiUserFeedbackControllerFindAll } from "./aiUserFeedbackControllerFindAll";
import { aiUserFeedbackControllerFindBulk } from "./aiUserFeedbackControllerFindBulk";
import { aiUserFeedbackControllerFindById } from "./aiUserFeedbackControllerFindById";
import { aiUserFeedbackControllerUpdate } from "./aiUserFeedbackControllerUpdate";

export function aiUserFeedbackService() {
  return { aiUserFeedbackControllerCreate, aiUserFeedbackControllerFindAll, aiUserFeedbackControllerFindBulk, aiUserFeedbackControllerFindById, aiUserFeedbackControllerUpdate, aiUserFeedbackControllerDelete }
}